const complex = (customer, row) => {
    return `
    <div>${row.name}</div>
    <small class="d-block text-light font-weight-light">${row.user_email}</small>
    `;
}

export default {
    complex
}